import {OrderItem} from './order-item';
import {TabCredit} from './tab-credit';
import {Tab} from './tab';
import {BaseFormModel} from './base-form-model';

export class ModifiedTabComponents extends BaseFormModel<ModifiedTabComponents> {
    items: OrderItem[];
    addedTabCredits: TabCredit[];
    removedTabCredits: TabCredit[];
    tab: Tab;
}
